const DEFAULT_BROWSER_TITLE = 'Dragon Tech — Gestor + CRM inteligente';
const DEFAULT_FAVICON = '/favicon.png?v=dt2910';

/**
 * Título da aba: custom → nome do escritório → default Dragon Tech.
 */
export function resolveBrowserTitle({ browser_title, brand_name } = {}) {
  const custom = String(browser_title || '').trim();
  if (custom) return custom.slice(0, 80);
  const brand = String(brand_name || '').trim();
  if (brand) return brand;
  return DEFAULT_BROWSER_TITLE;
}

function faviconMime(url) {
  const path = String(url || '').split('?')[0].toLowerCase();
  if (path.endsWith('.ico')) return 'image/x-icon';
  if (path.endsWith('.svg')) return 'image/svg+xml';
  if (path.endsWith('.png')) return 'image/png';
  if (path.endsWith('.webp')) return 'image/webp';
  if (path.endsWith('.jpg') || path.endsWith('.jpeg')) return 'image/jpeg';
  return '';
}

/**
 * Aplica título e favicon da aba do navegador a partir do branding do escritório.
 */
export function applyBrowserBrand({ browser_title, brand_name, favicon_url } = {}) {
  if (typeof document === 'undefined') return;

  document.title = resolveBrowserTitle({ browser_title, brand_name });

  const href = String(favicon_url || '').trim() || DEFAULT_FAVICON;
  // A single tab icon prevents the browser from choosing an old PWA-size icon.
  // rel~=icon also covers "shortcut icon", but never apple-touch-icon/manifest.
  const icons = [...document.head.querySelectorAll('link[rel~="icon"]')];
  const link = icons.find(icon => icon.getAttribute('data-aurax-favicon') === '1')
    || icons[0] || document.createElement('link');
  icons.forEach(icon => { if (icon !== link) icon.remove(); });
  link.setAttribute('data-aurax-favicon', '1');
  link.rel = 'icon';
  link.removeAttribute('sizes');
  link.removeAttribute('media');
  const mime = faviconMime(href);
  if (mime) link.type = mime;
  else link.removeAttribute('type');
  if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  if (!link.isConnected) document.head.appendChild(link);
}

export default applyBrowserBrand;
